import React from "react";
import { Card, Typography, Row, Col } from "antd";
import ReactApexChart from "react-apexcharts";
import { Link } from "react-router-dom";
import { EyeOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

export default function CustomerComplaintCard({ data, label }) {
  const statusData = {
    Total: (data || []).reduce((sum, item) => sum + (item.Count || 0), 0),
    Inprogress:
      (data || []).find((item) => item.Status === "Inprogress")?.Count || 0,
    Closed: (data || []).find((item) => item.Status === "Closed")?.Count || 0,
    Open: (data || []).find((item) => item.Status === "Open")?.Count || 0,
    Unknown: (data || []).find((item) => item.Status === "Unknown")?.Count || 0,
  };

  const chartSeries = [
    statusData.Inprogress,
    statusData.Closed,
    statusData.Open,
    statusData.Unknown,
  ].filter((val) => val > 0);

  const chartLabels = ["Inprogress", "Closed", "Open", "Unknown"].filter(
    (_, index) => chartSeries[index] > 0
  );

  const donutOptions = {
    chart: {
      type: "donut",
      animations: {
        enabled: true,
        easing: "easeinout",
        speed: 600,
      },
    },
    labels: chartLabels,
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
        donut: {
          size: "65%",
          labels: {
            show: true,
            total: {
              show: true,
              label: "Total",
              fontSize: "14px",
              fontWeight: 600,
              formatter: () => `${statusData.Total}`,
            },
          },
        },
      },
    },
    dataLabels: { enabled: false },
    legend: {
      position: "bottom",
      fontSize: "12px",
    },
    tooltip: {
      y: {
        formatter: (val) => `${val}`,
      },
    },
    colors: ["#c13c59", "#992038", "#e04e65", "#b9324c"],
    responsive: [
      {
        breakpoint: 768,
        options: {
          chart: {
            height: 220,
          },
        },
      },
    ],
  };

  const cardStyle = {
    borderRadius: 12,
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
    background: "linear-gradient(135deg, #fdfdfd 0%, #ffffff 100%)",
    height: "100%"
  };

  const textStyle = {
    fontSize: 14,
    color: "#555",
  };

  const titleStyle = { fontWeight: 600, marginBottom: 12 };

  return (
    <Card style={cardStyle} bodyStyle={{ padding: 20 }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Title level={5} style={{ ...titleStyle, color: "#1565c0" }}>
          {label} Status
        </Title>
        <Link to="/customercomplaints">
          <EyeOutlined style={{ fontSize: '16px', cursor: "pointer" }} />
        </Link>
      </div>
      <Row gutter={[24, 24]} align="middle">
        <Col xs={24} md={10}>
          <Text strong style={{ fontSize: 28, display: "block", marginBottom: 16 }}>
            Total: {statusData.Total}
          </Text>

          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {Object.entries(statusData).map(([key, value]) => {
              if (key !== "Total") {
                return (
                  <div key={key} style={{ display: "flex", justifyContent: "space-between" }}>
                    <Text style={textStyle}>{key}</Text>
                    <Text strong style={{ fontSize: 15 }}>{value}</Text>
                  </div>
                );
              }
              return null;
            })}
          </div>
        </Col>

        <Col
          xs={24}
          md={14}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ width: "100%", maxWidth: 320 }}>
            <ReactApexChart
              options={donutOptions}
              series={chartSeries.length > 0 ? chartSeries : [0]}
              type="donut"
              height={280}
            />
          </div>
        </Col>
      </Row>
    </Card>
  );
}
